import type { TaskSortBy } from '../../../server/dto/crm-task-dto.ts';
import { SortOrder } from '../../../server/types/list-view-types.ts';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';
import type { SortFilter } from '../../list-views/hooks/use-generic-list-view-sorting.tsx';
import { useGenericListViewSorting } from '../../list-views/hooks/use-generic-list-view-sorting.tsx';
import { useTaskListFilters } from './use-task-filters-state.ts';

export function useTaskListSorting() {
    const {
        appliedFilters: { sortingFilter },
        setAppliedFilters,
    } = useTaskListFilters();
    const sendEvent = useAnalytics();

    return useGenericListViewSorting<TaskSortBy>(
        sortingFilter,
        (sortingFilter: SortFilter<TaskSortBy> | undefined) => {
            setAppliedFilters((filters) => ({
                ...filters,
                sortingFilter: sortingFilter ?? undefined,
            }));
            if (sortingFilter) {
                sendEvent('task_overview_sort_used', {
                    column: sortingFilter.field,
                    direction: sortingFilter.direction === SortOrder.DESC ? 'DESC' : 'ASC',
                });
            }
        },
    );
}
